export const currentUser = (state) => state.currentUser
export const getUsers = (state) => state.users
export const getUser = (state) => state.user
export const getRestaurantUser = (state) => (id) => state.users.find(x => x.id === id) || {}